import '../base/palette'; // side-effect: keep the MUI augmentation reachable in declaration output
import { colors } from '@airship-platform/jam-design-tokens';
import { PaletteColorOptions, PaletteOptions } from '@mui/material/styles';
import { basePalette } from '../base/palette';

declare module '@mui/material/styles' {
  interface AirshipPaletteColorOptions {
    primary: string;
    secondary: string;
    accent: string;
    softButton: 'softRed' | 'softBlue' | 'softGold';
    colorName: 'red' | 'blue' | 'gold';
  }

  interface Palette {
    softRed?: PaletteColorOptions;
    softGray?: PaletteColorOptions;
    softBlue?: PaletteColorOptions;
    softGreen?: PaletteColorOptions;
    softGold?: PaletteColorOptions;
    airshipRed?: AirshipPaletteColorOptions;
    airshipGold?: AirshipPaletteColorOptions;
    airshipBlue?: AirshipPaletteColorOptions;
  }
  interface PaletteOptions {
    softRed?: PaletteColorOptions;
    softGray?: PaletteColorOptions;
    softBlue?: PaletteColorOptions;
    softGreen?: PaletteColorOptions;
    softGold?: PaletteColorOptions;
    airshipRed?: AirshipPaletteColorOptions;
    airshipGold?: AirshipPaletteColorOptions;
    airshipBlue?: AirshipPaletteColorOptions;
  }
}

export const platformPalette: PaletteOptions = {
  ...basePalette,
  softGreen: {
    ...colors.green,
    main: colors.green[50],
    dark: colors.green[100],
    light: colors.green[200],
    contrastText: colors.green[700],
  },
  softGold: {
    ...colors.gold,
    main: colors.gold[50],
    dark: colors.gold[100],
    light: colors.gold[200],
    contrastText: colors.gold[700],
  },
  softRed: {
    ...colors.red,
    main: colors.red[50],
    dark: colors.red[100],
    light: colors.red[200],
    contrastText: colors.red[700],
  },
  softGray: {
    ...colors.gray,
    main: colors.gray[50],
    dark: colors.gray[100],
    light: colors.gray[50],
    contrastText: colors.gray[700],
  },
  softBlue: {
    ...colors.blue,
    main: colors.blue[50],
    dark: colors.blue[100],
    light: colors.blue[50],
    contrastText: colors.blue[600],
  },
  airshipRed: {
    primary: colors.red[800],
    secondary: colors.red[300],
    accent: colors.red[200],
    softButton: 'softRed',
    colorName: 'red',
  },
  airshipGold: {
    primary: colors.gold[800],
    secondary: colors.gold[300],
    accent: colors.gold[200],
    softButton: 'softGold',
    colorName: 'gold',
  },
  airshipBlue: {
    primary: colors.blue[800],
    secondary: colors.blue[300],
    accent: colors.blue[200],
    softButton: 'softBlue',
    colorName: 'blue',
  },
};
